import { doesCarHaveCriticalFault } from "_helperFunctions/doesCarHaveCriticalFault";
export const hasFaults = function (car) {
    return (car.GuardianCapable !== false) && doesCarHaveCriticalFault(car.GpsiCarId);
 };